export default {
  ApiErrors: {
    generic: 'S’ha produït un error. Si us plau, recarrega la pàgina i contacta’ns si el problema persisteix.',
    'Email already exists': 'Correu electrònic no disponible',
    'This field is required.': 'Aquest camp és obligatori',
    'First_name must be filled': 'El nom ha de ser completat',
    'Password length must be over 8 characters': 'La contrasenya ha de tenir més de 8 caràcters',
    'Unable to login with the provided credentials': 'No es pot iniciar sessió amb les credencials proporcionades',
    'godson is already a customer': 'Aquest correu electrònic ja pertany a un client',
    'godson is in referral process': 'Aquest correu electrònic ja està en procés de recomanació',
    'Enter a valid email address': 'Aquesta no és una adreça de correu electrònic vàlida',
    'Email already in db': 'Correu electrònic no disponible',
    'Not an email': 'Correu electrònic no vàlid',
    'Reward is soldout': 'Aquesta recompensa està exhaurida',
    'Reward can only be claimed once': 'Ja has reclamat aquesta recompensa',
    'Reward is no longer valid': 'Aquesta recompensa ja no és vàlida',
    'Not enough points': 'No tens prou punts',
    'Account already in use': 'Aquest compte ja està sent utilitzat per un altre usuari',
    'This instagram account does not exist on Instagram': 'Aquest compte d’Instagram no existeix',
    'social error': "Si us plau, introdueix el teu compte {'@'}el_meu_compte",
    'required field': 'Si us plau, completa aquest camp',
    'value error': 'El valor introduït no és correcte',
    'You already applied a discount code': 'Ja has aplicat un codi de descompte'
  },
  Error: {
    generic: 'S’ha produït un error, si us plau recarrega la pàgina.',
    link: 'Recarregar la pàgina',
    title: 'Loyoly - Ups! Error',
    blacklistMessage1: 'No ets elegible per al programa de fidelització.',
    blacklistMessage2: 'Contacta amb l’equip de suport si creus que això és un error.'
  },
  FormEmail: {
    example: "johndoe{'@'}gmail.com",
    errors: {
      email: 'Si us plau, introdueix una adreça de correu electrònic vàlida',
      emailEmpty: 'Si us plau, introdueix la teva adreça de correu electrònic'
    }
  },
  InApp: {
    message: 'Per a una experiència òptima, utilitza el teu navegador predeterminat'
  },
  Phone: {
    countrySelector: {
      placeholder: 'Codi del país',
      error: 'Tria un país',
      searchPlaceholder: 'Selecciona un país'
    },
    phoneInput: {
      placeholder: 'Número de telèfon',
      example: 'Exemple:'
    },
    error: {
      invalid: 'Si us plau, introdueix un número de telèfon vàlid'
    }
  },
  Instagram: {
    ModalNotLinked: {
      title: 'Connectar amb el meu compte d’Instagram',
      subtitle: 'Com funciona',
      description:
        'Si us plau, introdueix el teu compte d’Instagram i assegura’t que sigui públic abans de completar les missions.',
      form: {
        username: 'Compte d’Instagram',
        usernameExample: "{'@'}johndoe"
      },
      errors: {
        usernameEmpty: 'Si us plau, introdueix el nom del teu compte',
        usernameNotFound: 'Si us plau, introdueix un nom de compte vàlid'
      },
      button: 'Validar'
    },
    ModalSearching: {
      title: 'Estem cercant el teu compte'
    },
    ModalLinked: {
      title: 'Connectar amb el meu compte d’Instagram',
      private: {
        subtitle: 'No es pot connectar amb el teu compte',
        description: {
          title: 'El teu compte d’Instagram és privat',
          text: 'Vaja, sembla que el teu compte d’Instagram és privat. Canvia’l a mode públic per accedir a totes les missions.'
        }
      },
      public: {
        subtitle: 'Connexió amb el teu compte correcta',
        description: {
          title: 'Felicitats',
          text: 'Ara pots realitzar les missions.'
        }
      },
      buttons: {
        edit: 'Editar el meu compte',
        retry: 'Reintentar',
        goback: 'Tornar a la pàgina',
        gotoChallenge: 'Anar a la missió'
      }
    },
    ModalNotFound: {
      title: 'Connectar amb el meu compte d’Instagram',
      subtitle: 'No es pot connectar amb el teu compte',
      description: {
        title: 'Compte no trobat',
        text: 'Et convidem a canviar de compte o fer una sol·licitud al suport.'
      },
      buttons: {
        change: 'Canviar de compte',
        retry: 'Reintentar'
      }
    }
  },
  Modal: {
    Notifications: {
      title: 'Notificacions per correu electrònic',
      information: {
        title: 'Informació',
        text: 'Si no vols rebre recordatoris de missions, notícies o recordatoris de recompenses, pots donar-te de baixa desactivant les caselles a continuació:'
      },
      communication: {
        optinTransactional: 'Promocional: informació sobre el programa, nivells VIP, recompenses.',
        optinMarketing: 'Informació sobre compres i patrocinis.'
      }
    },
    SocialAccount: {
      Info: {
        public: 'Compte públic',
        private: 'Compte privat',
        followers: '<span class="weglot-ignore">{n}</span> seguidor | <span class="weglot-ignore">{n}</span> seguidors'
      }
    }
  },
  Points: '<span class="weglot-ignore">{n}</span> punt | <span class="weglot-ignore">{n}</span> punts',
  PointsDecimal: '<span class="weglot-ignore">{value}</span> punt | <span class="weglot-ignore">{value}</span> punts',
  SectionHeader: {
    poweredBy: 'Desenvolupat per'
  },
  SectionChallenges: {
    empty: 'No hi ha missions disponibles en el teu programa de fidelització',
    showAll: 'Mostrar tot',
    ModalMissionDetail: {
      description: 'Descripció',
      pointsToEarn: 'Punts a guanyar',
      howto: 'Com funciona?',
      uploadMedia: 'Puja el teu arxiu',
      reviewApplication: 'Deixar una ressenya',
      linkApplication: 'Descarregar l’aplicació',
      newsletterPartners:
        'En fer clic a "Validar la missió", acceptes rebre ofertes comercials de l’empresa per mitjans electrònics.',
      phonePartners: 'Accepto que el meu número de telèfon sigui utilitzat per rebre ofertes per SMS.',
      clue: 'Pista',
      linkPage: 'Veure la pàgina',
      instaMention: 'Etiqueta',
      tiktokMention: 'Etiqueta',
      instaHashtags: 'Hashtag(s) a utilitzar',
      tiktokHashtags: 'Hashtag(s) a utilitzar',
      linkToShare: 'Enllaç per posar a la teva història',
      linkShare: 'Enllaç per compartir',
      vouchertoShare: 'Codi promocional per compartir',
      goToAccount: 'Anar al compte',
      goToInsta: 'Anar al compte',
      goToInstaPost: 'Anar a la publicació d’Instagram',
      goToInstaReel: 'Anar al reel d’Instagram',
      goToInstaIGTV: 'Anar a l’IGTV d’Instagram',
      goToTweeterTweet: 'Anar al tweet',
      goToReview: 'Deixar una ressenya',
      goToShop: 'Anar a la botiga',
      goToLink: 'Anar a la pàgina',
      goToTypeform: 'Completar el formulari',
      goToWhatsapp: 'Unir-se al grup',
      submit: 'Validar la missió',
      missionPendingTitle: 'Missió en verificació',
      missionPendingExplain: 'Els teus punts s’acreditaran aviat.',
      actionSurveyTextError: 'Si us plau, selecciona una resposta',
      actionEmailError: 'El teu correu electrònic no és vàlid',
      actionInputError: 'Aquest camp no és vàlid',
      actionInputImageError: 'Si us plau, puja el teu arxiu',
      handlingMedia: 'Processant el fitxer',
      errorMediaHandle: 'S’ha produït un error en processar el teu fitxer',
      imageInvalid: 'S’ha produït un error en processar el teu fitxer',
      videoSize: 'La mida del teu vídeo ha de ser inferior a 100 MB.',
      errorInstaReel: 'La URL del teu reel és incorrecta',
      'This url is not a valid google url': 'La URL de la teva ressenya de Google no és vàlida',
      'This url is not a valid reel url': 'La URL del teu reel és incorrecta',
      refusalReasonCondition: 'Incompliment de les condicions',
      refusalReasonQuality: 'Qualitat massa baixa',
      refusalReasonContent: 'Contingut inapropiat',
      refusalReasonSound: 'So inaudible',
      missionInvalidTitle: 'Missió invàlida',
      missionInvalidDescription: 'Pots repetir la missió seguint atentament les regles requerides',
      missionInvalidReasons: 'Raó del rebuig:',
      condition: 'Condicions',
      conditionExplanation: 'Tenir més de',
      ineligible: 'No elegible',
      ineligibleExplanation:
        'Sembla que no tens la quantitat de seguidors requerida. Si tens més seguidors, t’invitem a actualitzar les dades del teu compte.',
      lastUpdate: 'Última actualització el',
      updateAccount: 'Actualitzar el meu compte',
      reviewLastPurchase: 'Deixar una ressenya a la pàgina del producte de la teva última compra',
      whenReviewValidated: 'Un cop la ressenya sigui validada, la teva missió es validarà automàticament',
      pointsToEarnPhoto: 'Punts addicionals si puges una foto',
      pointsToEarnVideo: 'Punts addicionals si puges un vídeo',
      howtoBirthdate: 'Introdueix la teva data de naixement',
      errorInvalidDate: 'Si us plau, introdueix una data vàlida',
      inputMedia: 'Puja el teu arxiu',
      inputMediaLoaded: 'El teu fitxer s’ha pujat correctament',
      placeholderAnswer: 'Escriu la teva resposta aquí',
      misteryAnswer: 'Quina és la paraula misteriosa?',
      newsletterEmail: 'Confirma la teva adreça de correu electrònic',
      birthDate: 'Data de naixement',
      example: 'Exemple',
      goToChallenge: 'Anar a la missió'
    },
    ModalMissionImageRights: {
      imageRights:
        'En marcar aquesta casella, confirmo que sóc l’autor del contingut, accepto expressament cedir els drets de propietat intel·lectual associats i autoritzo l’ús de la meva imatge per part de la marca amb fins comercials segons els termes i condicions especificats en ',
      imageRightsLink: 'aquest acord.',
      title:
        'Acord de cessió de drets de propietat intel·lectual sobre el contingut i autorització per a l’explotació dels meus atributs de personalitat.',
      content:
        'Accepto expressament que la publicació del contingut realitzat en el marc de la meva missió (el “Contingut”):',
      bullet1:
        'implica la cessió, a favor de la marca, de la totalitat dels drets d’autor relacionats, per a tot el món, durant tota la durada legal de protecció del dret d’autor, de manera exclusiva i definitiva. Reconeixo que aquesta cessió es realitza com a contraprestació pels punts obtinguts en el marc de la meva missió, que constitueixen una compensació justa. Aquesta cessió inclou el dret de la marca a reproduir i representar el Contingut, total o parcialment, en tots els suports i per tots els mitjans, existents o futurs, previsibles o imprevisibles, així com el dret a traduir, modificar, adaptar, corregir i/o transformar el Contingut, per part de la marca, sola o en col·laboració amb tercers. Em comprometo que aquest Contingut no infringeixi els drets de tercers ni constitueixi una infracció, i garanteixo a la marca en aquest sentit;',
      bullet2:
        'implica l’autorització gratuïta a la marca per fixar, reproduir, difondre i comunicar al públic els meus atributs de personalitat associats al Contingut, en tots els suports i per tots els mitjans coneguts o no, previsibles o imprevisibles, a través de qualsevol mitjà, xarxa i canal de difusió, amb fins d’explotació, informació, comunicació, promoció i publicitat dels productes de la marca, per un període de 10 anys, prorrogable si cal mitjançant acord mutu.',
      end1: 'El present acord es regeix pel dret francès i serà interpretat conforme a aquest.',
      end2: 'Qualsevol disputa relativa a la seva validesa, interpretació ou execució serà sotmesa a la jurisdicció exclusiva dels Tribunals de París, llevat disposició processal en contrari.'
    },
    ModalMissionLoyaltyDetail: {
      pointsToEarn:
        '<span class="weglot-ignore">{points}</span> punt a guanyar per cada <span class="weglot-ignore">{amountToPoints}</span> gastats | <span class="weglot-ignore">{points}</span> punts a guanyar per cada <span class="weglot-ignore">{amountToPoints}</span> gastats',
      orderNumber: 'Comanda núm.',
      orderDate: 'Data',
      orderAmount: 'Import',
      orderRewardable: 'Recompensable',
      orderPoints: 'Punts guanyats',
      orderPaid: 'Validat',
      orderStatus: 'Estat',
      orderCancel: 'Reemborsat',
      orderRefund: 'Parcialment reemborsat',
      orderWaiting: 'Pendent'
    },
    CompanyConditions: {
      seeTermsAndConditions: 'Veure les condicions',
      seePrivacy: 'Veure la privacitat'
    }
  },
  SectionProfile: {
    socialNetworks: {
      instagram: 'Connectar a Instagram',
      tiktok: 'Connectar a TikTok'
    },
    notificationsByEmails: 'Notificacions per correu electrònic',
    cgu: 'Termes i condicions'
  },
  SectionAccountRewards: {
    empty: 'No hi ha més recompenses per bescanviar i no tens recompenses pendents d’ús',
    copied: 'Copiat!'
  },
  SectionRewards: {
    empty: 'No hi ha recompenses disponibles en el teu programa de fidelització',
    showAll: 'Mostrar tot',
    Card: {
      channel_store: 'En la tienda',
      channel_online: 'Online',
      channel_both: 'Online y en la tienda'
    }
  },
  SectionRewardsModalMyRewards: {
    title: 'Les meves recompenses',
    empty: 'Encara no tens recompenses.',
    emptyTip: 'Pots completar missions i bescanviar els punts guanyats per recompenses',
    use: 'Utilitzar',
    expired: 'Caducada'
  },
  SectionRewardsDetailInfos: {
    expireDate: 'Data de caducitat',
    expirationDelayExplain:
      'La recompensa serà utilitzable durant <span class="weglot-ignore">{expiration_delay}</span> dies un cop l’hagis bescanviat.',
    minimumBuy: 'Compra mínima',
    maxAmount: 'Vàlid fins a',
    description: 'Descripció',
    saleChannel: 'Canal de venda',
    channelStore: 'A la botiga',
    channelOnline: 'En línia',
    channelBoth: 'En línia i a la botiga'
  },
  SectionRewardsDetailModal: {
    exchange: 'Bescanviar',
    errorMessage1: 'Sembla que ha ocorregut un problema.',
    errorMessage2: 'La teva recompensa no s’ha intercanviat i els teus punts no s’han descomptat.',
    errorMessage3: 'Si us plau, recarrega la pàgina.',
    errorButton: 'Recarregar la pàgina'
  },
  SectionRewardsClaimModal: {
    howItWorks: 'Com funciona?',
    howItWorkCode: 'Utilitza el teu codi al nostre lloc web en fer la comanda',
    howItWorkCodeProduct: 'Afegeix el producte al teu carret i després utilitza el codi en fer la comanda',
    howItWorkCodeRecharge: 'Afegeix el codi directament al teu portal de client',
    howItWorkExt: 'Se’t contactarà per rebre la teva recompensa',
    applyToBasket: 'Aplicar al carret',
    apply: 'Aplicar',
    applied: 'Aplicat',
    link: 'Enllaç al producte',
    copied: 'Copiat!',
    customerPortal: 'Portal de client',
    nonApplicable: 'No elegible'
  },
  SectionRewardsDetailsRechargeSubscriptions: {
    apply: 'Aplicar',
    nonApplicable: 'No elegible',
    itemTitle: '{title} / {price}',
    customerPortal: 'Portal de client'
  },
  SectionReferral: {
    friendEmail: 'Correu electrònic del teu amic',
    seeReferral: 'Veure les meves referències',
    Tabs: {
      link: 'Enllaç',
      email: 'Correu electrònic',
      sms: 'SMS',
      copy: 'Copiar enllaç',
      smsSend: 'Enviar un missatge',
      reward1: '{amount} punts',
      reward2: '{amount}% de descompte',
      reward3: '{amount} val',
      smsTemplate:
        'Hola! He descobert {brand_name} que et podria agradar.\n\n Amb el meu enllaç de recomanació {referral_link}, et beneficiaràs de {reward_friend}.\n\nAprofita-ho, és una oferta realment interessant!\nFins aviat!'
    },
    errors: {
      emailSelf: 'El correu electrònic introduït és el mateix que el teu'
    },
    Modal: {
      emptyState: 'Encara no has fet cap referència',
      title: 'Les meves referències',
      status: 'Estat',
      email: 'Correu electrònic',
      date: 'Data de caducitat',
      statusPending: 'Pendent',
      statusUsed: 'Ja utilitzat',
      statusAvailable: 'Disponible',
      statusExpired: 'Caducat',
      statusInvalidate: 'Invalidat',
      promocodeComing: 'Pròximament',
      promocodeUnavailable: '-',
      promocodeInvalidate: 'Invalidat',
      points_given: 'Els teus punts han estat acreditats',
      referral_type_3: 'Val',
      referral_type_2: 'Codi promocional',
      referral_type_1: 'Punts'
    },
    NotAuthenticatedForm: {
      emailPlaceholder: 'Correu electrònic',
      emailError: 'El format del correu electrònic no és correcte',
      emailEmpty: 'Si us plau, completa aquest camp',
      emailUnknown: 'Si us plau, crea un compte per poder referir'
    }
  },
  SectionVipTiersProgress: {
    you: 'Tu',
    points: 'punts'
  },
  SectionVipTiersCard: {
    rewardPoints: '{points} punts de bonificació',
    rewardMultiplier: 'Multiplicador de punts: x{multiplier}',

    tiersPoints: '{amount} punts'
  },
  SectionGifting: {
    empty: 'No hi ha proves de productes disponibles en aquest moment',
    showAll: 'Mostrar tot',
    ModalApply: {
      endDate: 'Data de finalització de les aplicacions',
      description: 'Descripció',
      completeForm: 'Completa el formulari per enviar la teva sol·licitud',
      button: 'Aplicar',
      success: {
        title: 'Registre de prova de producte',
        description:
          'Gràcies per completar la teva informació. La teva sol·licitud està sent revisada. Se’t notificarà per correu electrònic.'
      },
      Form: {
        Errors: {
          required: 'Si us plau, completa aquest camp',
          date: 'Si us plau, introdueix una data vàlida'
        }
      }
    },
    ModalParticipate: {
      challenges: 'Missions',
      howItWorks: 'Com funciona?',
      useCode: 'Utilitza el teu codi al nostre lloc web en fer la comanda.',
      youWillBeContacted: 'Se’t contactarà per rebre el teu producte.',
      buttonLink: 'Enllaç al producte',
      buttonCopied: 'Copiat!'
    }
  },
  SectionGiftingCardList: {
    status: {
      participate: 'Participar',
      underValidation: 'En validació',
      apply: 'Aplicar',
      ended: 'Finalitzat',
      rejected: 'Sol·licitud no acceptada'
    }
  },
  SectionSteps: {
    Authenticated: {
      month: '{n} mes| {n} mesos'
    },
    ModalActivities: {
      title: 'Les meves activitats recents',
      empty: 'Encara no tens activitats recents.',
      table: {
        header: {
          title: 'Títol',
          points: 'Punts',
          date: 'Data'
        }
      },
      events: {
        challenge: 'Missió validada',
        order: 'Compra realitzada',
        reward: 'Recompensa obtinguda',
        refferal: 'Referència validada',
        userAction: 'Punts ajustats',
        level: 'Nivell assolit',
        levelLabel: 'Nivell {level}',
        reset: 'Caducitat dels punts',
        automation: 'Punts guanyats'
      }
    }
  },
  Tiktok: {
    ModalNotLinked: {
      title: 'Connectar amb el meu compte de TikTok',
      subtitle: 'Com funciona',
      description:
        'Si us plau, introdueix el teu compte de TikTok i assegura’t que sigui públic. Després podràs completar missions de TikTok.',
      button: 'Vincular el meu compte'
    },
    ModalLinked: {
      title: 'Connectar amb el meu compte de TikTok',
      subtitle: 'Connexió amb el teu compte correcta',
      congratulations: 'Felicitats',
      description: 'Ara pots realitzar missions.',
      buttons: {
        edit: 'Editar el meu compte',
        goback: 'Tornar a la pàgina'
      }
    }
  },
  SectionReferralFriend: {
    placeholder: 'Adreça de correu electrònic',
    emailError: 'Si us plau, introdueix una adreça de correu electrònic vàlida',
    emailEmpty: 'Si us plau, introdueix la teva adreça de correu electrònic',
    disclaimer: 'Aquesta oferta és vàlida només per a nous clients',
    disclaimerVerification: 'No seràs contactat amb fins comercials.',
    referral_type_3: 'Val de compra',
    referral_type_2: 'Codi promocional',
    referral_type_1: 'Punts',
    copied: 'Copiat!',
    label_optin_reminder: 'Vull rebre un recordatori si no utilitzo el meu descompte.',
    btn_optin_reminder: 'Rebre un recordatori del meu codi'
  },
  Unsubscribe: {
    title: 'Realment vols donar-te de baixa dels correus del nostre programa de fidelització?',
    description:
      'Si és així, tingues en compte que ja no rebràs informació sobre les teves recompenses, missions i punts.',
    email: 'Correu electrònic',
    button: 'Actualitzar les meves preferències',
    question: 'Quin tipus de correus vols rebre?',
    optinTransactional: 'Promocional: informació sobre el programa, nivells VIP, recompenses.',
    optinMarketing: 'Informació sobre compres i patrocinis.',
    successTitle: 'Les teves preferències s’han actualitzat',
    successDescription: 'Utilitza el botó de sota per revisar o modificar les teves preferències',
    successButton: 'Actualitzar les meves preferències',
    errorTitle: 'Hi ha un error amb l’enllaç de redirecció',
    errorButton: 'Redirigir al lloc web'
  },
  SectionAccount: {
    copied: 'Copiat!'
  },
  SectionPointCard: {
    you: 'Tu',
    copied: 'Copiat!'
  }
}
